import { Bookmark } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { t } from "i18next";
import type { MouseEventHandler } from "react";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { useProductDetailsUrl } from "~/common/components/PackageRestrictionContext/useProductDetailsUrl";
import { isProductPMA } from "~/feature/ProductDescriptor/v1/productDescriptorUtils";
import type { ProductDescriptor } from "~/feature/ProductDescriptor/v1/types";

import { InfoProductMessagePMA } from "~/ProductDetails/components/ProductSummary/InfoProductMessagePMA";
import { redirectToUrl } from "~/utils/url/urlUtils";

const AddToWishlistSmall = ({ onClick }: { onClick?: MouseEventHandler<HTMLButtonElement> }) => {
  return (
    <IconButton
      key={"wishlist"}
      onClick={onClick}
      color="secondary"
      variant="contained"
      data-test-id={"button-wishlist"}
    >
      <Bookmark />
    </IconButton>
  );
};

const AddToCart = ({
  onClick,
  disabled,
  productDescriptor,
}: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled: boolean;
  productDescriptor: ProductDescriptor;
}) => {
  const url = useProductDetailsUrl(productDescriptor.base);
  if (isProductPMA(productDescriptor)) {
    return <InfoProductMessagePMA short={true} onClick={() => redirectToUrl(url)} />;
  }

  return (
    <Button
      size={"medium"}
      fullWidth={true}
      startIcon={<DefaultButtonIcon type={IconType.Cart} />}
      disabled={disabled}
      onClick={onClick}
      data-test-id={"button-addtocart"}
    >
      {t("addToCartPopup.add.submitBtn")}
    </Button>
  );
};

export const SrpButtons = {
  AddToWishlistSmall,
  AddToCart,
};
